export const ensureIsNumber = (value: number | string): number => {
  if (typeof value === 'number') {
    return value;
  }
  const num = Number(value);
  if (isNaN(num)) {
    throw new Error(`Cannot convert "${value}" to number`);
  }
  return num;
};
